export const countries = [
  {
    name: "Andorra",
    code: "AD",
    phoneCode: "+376",
    flagUrl: "https://country-code-au6g.vercel.app/AD.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    phoneCode: "+971",
    flagUrl: "https://country-code-au6g.vercel.app/AE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Afghanistan",
    code: "AF",
    phoneCode: "+93",
    flagUrl: "https://country-code-au6g.vercel.app/AF.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Antigua & Barbuda",
    code: "AG",
    phoneCode: "+1268",
    flagUrl: "https://country-code-au6g.vercel.app/AG.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Anguilla",
    code: "AI",
    phoneCode: "+1264",
    flagUrl: "https://country-code-au6g.vercel.app/AI.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Albania",
    code: "AL",
    phoneCode: "+355",
    flagUrl: "https://country-code-au6g.vercel.app/AL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Armenia",
    code: "AM",
    phoneCode: "+374",
    flagUrl: "https://country-code-au6g.vercel.app/AM.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Angola",
    code: "AO",
    phoneCode: "+244",
    flagUrl: "https://country-code-au6g.vercel.app/AO.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Antarctica",
    code: "AQ",
    phoneCode: "+672",
    flagUrl: "https://country-code-au6g.vercel.app/AQ.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Argentina",
    code: "AR",
    phoneCode: "+54",
    flagUrl: "https://country-code-au6g.vercel.app/AR.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "American Samoa",
    code: "AS",
    phoneCode: "+1684",
    flagUrl: "https://country-code-au6g.vercel.app/AS.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Austria",
    code: "AT",
    phoneCode: "+43",
    flagUrl: "https://country-code-au6g.vercel.app/AT.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 11,
  },
  {
    name: "Australia",
    code: "AU",
    phoneCode: "+61",
    flagUrl: "https://country-code-au6g.vercel.app/AU.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Aruba",
    code: "AW",
    phoneCode: "+297",
    flagUrl: "https://country-code-au6g.vercel.app/AW.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Åland Islands",
    code: "AX",
    phoneCode: "+358",
    flagUrl: "https://country-code-au6g.vercel.app/AX.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
  {
    name: "Azerbaijan",
    code: "AZ",
    phoneCode: "+994",
    flagUrl: "https://country-code-au6g.vercel.app/AZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Bosnia & Herzegovina",
    code: "BA",
    phoneCode: "+387",
    flagUrl: "https://country-code-au6g.vercel.app/BA.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Barbados",
    code: "BB",
    phoneCode: "+1246",
    flagUrl: "https://country-code-au6g.vercel.app/BB.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Bangladesh",
    code: "BD",
    phoneCode: "+880",
    flagUrl: "https://country-code-au6g.vercel.app/BD.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Belgium",
    code: "BE",
    phoneCode: "+32",
    flagUrl: "https://country-code-au6g.vercel.app/BE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Burkina Faso",
    code: "BF",
    phoneCode: "+226",
    flagUrl: "https://country-code-au6g.vercel.app/BF.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Bulgaria",
    code: "BG",
    phoneCode: "+359",
    flagUrl: "https://country-code-au6g.vercel.app/BG.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Bahrain",
    code: "BH",
    phoneCode: "+973",
    flagUrl: "https://country-code-au6g.vercel.app/BH.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Burundi",
    code: "BI",
    phoneCode: "+257",
    flagUrl: "https://country-code-au6g.vercel.app/BI.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Benin",
    code: "BJ",
    phoneCode: "+229",
    flagUrl: "https://country-code-au6g.vercel.app/BJ.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "St. Barthélemy",
    code: "BL",
    phoneCode: "+590",
    flagUrl: "https://country-code-au6g.vercel.app/BL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Bermuda",
    code: "BM",
    phoneCode: "+1441",
    flagUrl: "https://country-code-au6g.vercel.app/BM.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Brunei",
    code: "BN",
    phoneCode: "+673",
    flagUrl: "https://country-code-au6g.vercel.app/BN.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Bolivia",
    code: "BO",
    phoneCode: "+591",
    flagUrl: "https://country-code-au6g.vercel.app/BO.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Brazil",
    code: "BR",
    phoneCode: "+55",
    flagUrl: "https://country-code-au6g.vercel.app/BR.svg",
    minPhoneDigits: 11,
    maxPhoneDigits: 11,
  },
  {
    name: "Bahamas",
    code: "BS",
    phoneCode: "+1242",
    flagUrl: "https://country-code-au6g.vercel.app/BS.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Bhutan",
    code: "BT",
    phoneCode: "+975",
    flagUrl: "https://country-code-au6g.vercel.app/BT.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Botswana",
    code: "BW",
    phoneCode: "+267",
    flagUrl: "https://country-code-au6g.vercel.app/BW.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Belarus",
    code: "BY",
    phoneCode: "+375",
    flagUrl: "https://country-code-au6g.vercel.app/BY.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Belize",
    code: "BZ",
    phoneCode: "+501",
    flagUrl: "https://country-code-au6g.vercel.app/BZ.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Canada",
    code: "CA",
    phoneCode: "+1",
    flagUrl: "https://country-code-au6g.vercel.app/CA.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Cocos (Keeling) Islands",
    code: "CC",
    phoneCode: "+61",
    flagUrl: "https://country-code-au6g.vercel.app/CC.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Congo - Kinshasa",
    code: "CD",
    phoneCode: "+243",
    flagUrl: "https://country-code-au6g.vercel.app/CD.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Central African Republic",
    code: "CF",
    phoneCode: "+236",
    flagUrl: "https://country-code-au6g.vercel.app/CF.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Congo - Brazzaville",
    code: "CG",
    phoneCode: "+242",
    flagUrl: "https://country-code-au6g.vercel.app/CG.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Switzerland",
    code: "CH",
    phoneCode: "+41",
    flagUrl: "https://country-code-au6g.vercel.app/CH.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Côte d’Ivoire",
    code: "CI",
    phoneCode: "+225",
    flagUrl: "https://country-code-au6g.vercel.app/CI.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Cook Islands",
    code: "CK",
    phoneCode: "+682",
    flagUrl: "https://country-code-au6g.vercel.app/CK.svg",
    minPhoneDigits: 5,
    maxPhoneDigits: 5,
  },
  {
    name: "Chile",
    code: "CL",
    phoneCode: "+56",
    flagUrl: "https://country-code-au6g.vercel.app/CL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Cameroon",
    code: "CM",
    phoneCode: "+237",
    flagUrl: "https://country-code-au6g.vercel.app/CM.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "China",
    code: "CN",
    phoneCode: "+86",
    flagUrl: "https://country-code-au6g.vercel.app/CN.svg",
    minPhoneDigits: 11,
    maxPhoneDigits: 11,
  },
  {
    name: "Colombia",
    code: "CO",
    phoneCode: "+57",
    flagUrl: "https://country-code-au6g.vercel.app/CO.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Costa Rica",
    code: "CR",
    phoneCode: "+506",
    flagUrl: "https://country-code-au6g.vercel.app/CR.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Cuba",
    code: "CU",
    phoneCode: "+53",
    flagUrl: "https://country-code-au6g.vercel.app/CU.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Cape Verde",
    code: "CV",
    phoneCode: "+238",
    flagUrl: "https://country-code-au6g.vercel.app/CV.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Christmas Island",
    code: "CX",
    phoneCode: "+61",
    flagUrl: "https://country-code-au6g.vercel.app/CX.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Cyprus",
    code: "CY",
    phoneCode: "+357",
    flagUrl: "https://country-code-au6g.vercel.app/CY.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Czechia",
    code: "CZ",
    phoneCode: "+420",
    flagUrl: "https://country-code-au6g.vercel.app/CZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Germany",
    code: "DE",
    phoneCode: "+49",
    flagUrl: "https://country-code-au6g.vercel.app/DE.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 11,
  },
  {
    name: "Djibouti",
    code: "DJ",
    phoneCode: "+253",
    flagUrl: "https://country-code-au6g.vercel.app/DJ.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Denmark",
    code: "DK",
    phoneCode: "+45",
    flagUrl: "https://country-code-au6g.vercel.app/DK.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Dominica",
    code: "DM",
    phoneCode: "+1767",
    flagUrl: "https://country-code-au6g.vercel.app/DM.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Dominican Republic",
    code: "DO",
    phoneCode: "+1849",
    flagUrl: "https://country-code-au6g.vercel.app/DO.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Algeria",
    code: "DZ",
    phoneCode: "+213",
    flagUrl: "https://country-code-au6g.vercel.app/DZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Ecuador",
    code: "EC",
    phoneCode: "+593",
    flagUrl: "https://country-code-au6g.vercel.app/EC.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Estonia",
    code: "EE",
    phoneCode: "+372",
    flagUrl: "https://country-code-au6g.vercel.app/EE.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 8,
  },
  {
    name: "Egypt",
    code: "EG",
    phoneCode: "+20",
    flagUrl: "https://country-code-au6g.vercel.app/EG.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Eritrea",
    code: "ER",
    phoneCode: "+291",
    flagUrl: "https://country-code-au6g.vercel.app/ER.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Spain",
    code: "ES",
    phoneCode: "+34",
    flagUrl: "https://country-code-au6g.vercel.app/ES.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Ethiopia",
    code: "ET",
    phoneCode: "+251",
    flagUrl: "https://country-code-au6g.vercel.app/ET.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Finland",
    code: "FI",
    phoneCode: "+358",
    flagUrl: "https://country-code-au6g.vercel.app/FI.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
  {
    name: "Fiji",
    code: "FJ",
    phoneCode: "+679",
    flagUrl: "https://country-code-au6g.vercel.app/FJ.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Falkland Islands",
    code: "FK",
    phoneCode: "+500",
    flagUrl: "https://country-code-au6g.vercel.app/FK.svg",
    minPhoneDigits: 5,
    maxPhoneDigits: 5,
  },
  {
    name: "Micronesia",
    code: "FM",
    phoneCode: "+691",
    flagUrl: "https://country-code-au6g.vercel.app/FM.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Faroe Islands",
    code: "FO",
    phoneCode: "+298",
    flagUrl: "https://country-code-au6g.vercel.app/FO.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "France",
    code: "FR",
    phoneCode: "+33",
    flagUrl: "https://country-code-au6g.vercel.app/FR.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Gabon",
    code: "GA",
    phoneCode: "+241",
    flagUrl: "https://country-code-au6g.vercel.app/GA.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "United Kingdom",
    code: "GB",
    phoneCode: "+44",
    flagUrl: "https://country-code-au6g.vercel.app/GB.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Grenada",
    code: "GD",
    phoneCode: "+1473",
    flagUrl: "https://country-code-au6g.vercel.app/GD.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Georgia",
    code: "GE",
    phoneCode: "+995",
    flagUrl: "https://country-code-au6g.vercel.app/GE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "French Guiana",
    code: "GF",
    phoneCode: "+594",
    flagUrl: "https://country-code-au6g.vercel.app/GF.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },

  {
    name: "Ghana",
    code: "GH",
    phoneCode: "+233",
    flagUrl: "https://country-code-au6g.vercel.app/GH.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Gibraltar",
    code: "GI",
    phoneCode: "+350",
    flagUrl: "https://country-code-au6g.vercel.app/GI.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Greenland",
    code: "GL",
    phoneCode: "+299",
    flagUrl: "https://country-code-au6g.vercel.app/GL.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Gambia",
    code: "GM",
    phoneCode: "+220",
    flagUrl: "https://country-code-au6g.vercel.app/GM.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Guinea",
    code: "GN",
    phoneCode: "+224",
    flagUrl: "https://country-code-au6g.vercel.app/GN.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Guadeloupe",
    code: "GP",
    phoneCode: "+590",
    flagUrl: "https://country-code-au6g.vercel.app/GP.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Equatorial Guinea",
    code: "GQ",
    phoneCode: "+240",
    flagUrl: "https://country-code-au6g.vercel.app/GQ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Greece",
    code: "GR",
    phoneCode: "+30",
    flagUrl: "https://country-code-au6g.vercel.app/GR.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "South Georgia & South Sandwich Islands",
    code: "GS",
    phoneCode: "+500",
    flagUrl: "https://country-code-au6g.vercel.app/GS.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Guatemala",
    code: "GT",
    phoneCode: "+502",
    flagUrl: "https://country-code-au6g.vercel.app/GT.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Guam",
    code: "GU",
    phoneCode: "+1671",
    flagUrl: "https://country-code-au6g.vercel.app/GU.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Guinea-Bissau",
    code: "GW",
    phoneCode: "+245",
    flagUrl: "https://country-code-au6g.vercel.app/GW.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Guyana",
    code: "GY",
    phoneCode: "+595",
    flagUrl: "https://country-code-au6g.vercel.app/GY.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Hong Kong SAR China",
    code: "HK",
    phoneCode: "+852",
    flagUrl: "https://country-code-au6g.vercel.app/HK.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Honduras",
    code: "HN",
    phoneCode: "+504",
    flagUrl: "https://country-code-au6g.vercel.app/HN.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Croatia",
    code: "HR",
    phoneCode: "+385",
    flagUrl: "https://country-code-au6g.vercel.app/HR.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 9,
  },
  {
    name: "Haiti",
    code: "HT",
    phoneCode: "+509",
    flagUrl: "https://country-code-au6g.vercel.app/HT.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Hungary",
    code: "HU",
    phoneCode: "+36",
    flagUrl: "https://country-code-au6g.vercel.app/HU.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Indonesia",
    code: "ID",
    phoneCode: "+62",
    flagUrl: "https://country-code-au6g.vercel.app/ID.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 12,
  },
  {
    name: "Ireland",
    code: "IE",
    phoneCode: "+353",
    flagUrl: "https://country-code-au6g.vercel.app/IE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Israel",
    code: "IL",
    phoneCode: "+972",
    flagUrl: "https://country-code-au6g.vercel.app/IL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },

  {
    name: "India",
    code: "IN",
    phoneCode: "+91",
    flagUrl: "https://country-code-au6g.vercel.app/IN.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "British Indian Ocean Territory",
    code: "IO",
    phoneCode: "+246",
    flagUrl: "https://country-code-au6g.vercel.app/IO.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Iraq",
    code: "IQ",
    phoneCode: "+964",
    flagUrl: "https://country-code-au6g.vercel.app/IQ.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Iran",
    code: "IR",
    phoneCode: "+98",
    flagUrl: "https://country-code-au6g.vercel.app/IR.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Iceland",
    code: "IS",
    phoneCode: "+354",
    flagUrl: "https://country-code-au6g.vercel.app/IS.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Italy",
    code: "IT",
    phoneCode: "+39",
    flagUrl: "https://country-code-au6g.vercel.app/IT.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },

  {
    name: "Jamaica",
    code: "JM",
    phoneCode: "+1876",
    flagUrl: "https://country-code-au6g.vercel.app/JM.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Jordan",
    code: "JO",
    phoneCode: "+962",
    flagUrl: "https://country-code-au6g.vercel.app/JO.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Japan",
    code: "JP",
    phoneCode: "+81",
    flagUrl: "https://country-code-au6g.vercel.app/JP.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Kenya",
    code: "KE",
    phoneCode: "+254",
    flagUrl: "https://country-code-au6g.vercel.app/KE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Kyrgyzstan",
    code: "KG",
    phoneCode: "+996",
    flagUrl: "https://country-code-au6g.vercel.app/KG.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Cambodia",
    code: "KH",
    phoneCode: "+855",
    flagUrl: "https://country-code-au6g.vercel.app/KH.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 9,
  },
  {
    name: "Kiribati",
    code: "KI",
    phoneCode: "+686",
    flagUrl: "https://country-code-au6g.vercel.app/KI.svg",
    minPhoneDigits: 5,
    maxPhoneDigits: 5,
  },
  {
    name: "Comoros",
    code: "KM",
    phoneCode: "+269",
    flagUrl: "https://country-code-au6g.vercel.app/KM.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "St. Kitts & Nevis",
    code: "KN",
    phoneCode: "+1869",
    flagUrl: "https://country-code-au6g.vercel.app/KN.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "North Korea",
    code: "KP",
    phoneCode: "+850",
    flagUrl: "https://country-code-au6g.vercel.app/KP.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "South Korea",
    code: "KR",
    phoneCode: "+82",
    flagUrl: "https://country-code-au6g.vercel.app/KR.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
  {
    name: "Kuwait",
    code: "KW",
    phoneCode: "+965",
    flagUrl: "https://country-code-au6g.vercel.app/KW.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Cayman Islands",
    code: "KY",
    phoneCode: "+ 345",
    flagUrl: "https://country-code-au6g.vercel.app/KY.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Kazakhstan",
    code: "KZ",
    phoneCode: "+77",
    flagUrl: "https://country-code-au6g.vercel.app/KZ.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Laos",
    code: "LA",
    phoneCode: "+856",
    flagUrl: "https://country-code-au6g.vercel.app/LA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
  {
    name: "Lebanon",
    code: "LB",
    phoneCode: "+961",
    flagUrl: "https://country-code-au6g.vercel.app/LB.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 8,
  },
  {
    name: "St. Lucia",
    code: "LC",
    phoneCode: "+1758",
    flagUrl: "https://country-code-au6g.vercel.app/LC.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Liechtenstein",
    code: "LI",
    phoneCode: "+423",
    flagUrl: "https://country-code-au6g.vercel.app/LI.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Sri Lanka",
    code: "LK",
    phoneCode: "+94",
    flagUrl: "https://country-code-au6g.vercel.app/LK.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Liberia",
    code: "LR",
    phoneCode: "+231",
    flagUrl: "https://country-code-au6g.vercel.app/LR.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 9,
  },
  {
    name: "Lesotho",
    code: "LS",
    phoneCode: "+266",
    flagUrl: "https://country-code-au6g.vercel.app/LS.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Lithuania",
    code: "LT",
    phoneCode: "+370",
    flagUrl: "https://country-code-au6g.vercel.app/LT.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Luxembourg",
    code: "LU",
    phoneCode: "+352",
    flagUrl: "https://country-code-au6g.vercel.app/LU.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Latvia",
    code: "LV",
    phoneCode: "+371",
    flagUrl: "https://country-code-au6g.vercel.app/LV.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Libya",
    code: "LY",
    phoneCode: "+218",
    flagUrl: "https://country-code-au6g.vercel.app/LY.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Morocco",
    code: "MA",
    phoneCode: "+212",
    flagUrl: "https://country-code-au6g.vercel.app/MA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Monaco",
    code: "MC",
    phoneCode: "+377",
    flagUrl: "https://country-code-au6g.vercel.app/MC.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Moldova",
    code: "MD",
    phoneCode: "+373",
    flagUrl: "https://country-code-au6g.vercel.app/MD.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Montenegro",
    code: "ME",
    phoneCode: "+382",
    flagUrl: "https://country-code-au6g.vercel.app/ME.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "St. Martin",
    code: "MF",
    phoneCode: "+590",
    flagUrl: "https://country-code-au6g.vercel.app/MF.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Madagascar",
    code: "MG",
    phoneCode: "+261",
    flagUrl: "https://country-code-au6g.vercel.app/MG.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Marshall Islands",
    code: "MH",
    phoneCode: "+692",
    flagUrl: "https://country-code-au6g.vercel.app/MH.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "North Macedonia",
    code: "MK",
    phoneCode: "+389",
    flagUrl: "https://country-code-au6g.vercel.app/MK.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Mali",
    code: "ML",
    phoneCode: "+223",
    flagUrl: "https://country-code-au6g.vercel.app/ML.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Myanmar (Burma)",
    code: "MM",
    phoneCode: "+95",
    flagUrl: "https://country-code-au6g.vercel.app/MM.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 10,
  },
  {
    name: "Mongolia",
    code: "MN",
    phoneCode: "+976",
    flagUrl: "https://country-code-au6g.vercel.app/MN.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Macao SAR China",
    code: "MO",
    phoneCode: "+853",
    flagUrl: "https://country-code-au6g.vercel.app/MO.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Northern Mariana Islands",
    code: "MP",
    phoneCode: "+1670",
    flagUrl: "https://country-code-au6g.vercel.app/MP.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Martinique",
    code: "MQ",
    phoneCode: "+596",
    flagUrl: "https://country-code-au6g.vercel.app/MQ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Mauritania",
    code: "MR",
    phoneCode: "+222",
    flagUrl: "https://country-code-au6g.vercel.app/MR.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Montserrat",
    code: "MS",
    phoneCode: "+1664",
    flagUrl: "https://country-code-au6g.vercel.app/MS.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Malta",
    code: "MT",
    phoneCode: "+356",
    flagUrl: "https://country-code-au6g.vercel.app/MT.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Mauritius",
    code: "MU",
    phoneCode: "+230",
    flagUrl: "https://country-code-au6g.vercel.app/MU.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Maldives",
    code: "MV",
    phoneCode: "+960",
    flagUrl: "https://country-code-au6g.vercel.app/MV.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Malawi",
    code: "MW",
    phoneCode: "+265",
    flagUrl: "https://country-code-au6g.vercel.app/MW.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Mexico",
    code: "MX",
    phoneCode: "+52",
    flagUrl: "https://country-code-au6g.vercel.app/MX.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Malaysia",
    code: "MY",
    phoneCode: "+60",
    flagUrl: "https://country-code-au6g.vercel.app/MY.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
  {
    name: "Mozambique",
    code: "MZ",
    phoneCode: "+258",
    flagUrl: "https://country-code-au6g.vercel.app/MZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Namibia",
    code: "NA",
    phoneCode: "+264",
    flagUrl: "https://country-code-au6g.vercel.app/NA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "New Caledonia",
    code: "NC",
    phoneCode: "+687",
    flagUrl: "https://country-code-au6g.vercel.app/NC.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Niger",
    code: "NE",
    phoneCode: "+227",
    flagUrl: "https://country-code-au6g.vercel.app/NE.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Norfolk Island",
    code: "NF",
    phoneCode: "+672",
    flagUrl: "https://country-code-au6g.vercel.app/NF.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Nigeria",
    code: "NG",
    phoneCode: "+234",
    flagUrl: "https://country-code-au6g.vercel.app/NG.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Nicaragua",
    code: "NI",
    phoneCode: "+505",
    flagUrl: "https://country-code-au6g.vercel.app/NI.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Netherlands",
    code: "NL",
    phoneCode: "+31",
    flagUrl: "https://country-code-au6g.vercel.app/NL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Norway",
    code: "NO",
    phoneCode: "+47",
    flagUrl: "https://country-code-au6g.vercel.app/NO.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Nepal",
    code: "NP",
    phoneCode: "+977",
    flagUrl: "https://country-code-au6g.vercel.app/NP.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Nauru",
    code: "NR",
    phoneCode: "+674",
    flagUrl: "https://country-code-au6g.vercel.app/NR.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Niue",
    code: "NU",
    phoneCode: "+683",
    flagUrl: "https://country-code-au6g.vercel.app/NU.svg",
    minPhoneDigits: 4,
    maxPhoneDigits: 4,
  },
  {
    name: "New Zealand",
    code: "NZ",
    phoneCode: "+64",
    flagUrl: "https://country-code-au6g.vercel.app/NZ.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 9,
  },
  {
    name: "Oman",
    code: "OM",
    phoneCode: "+968",
    flagUrl: "https://country-code-au6g.vercel.app/OM.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Panama",
    code: "PA",
    phoneCode: "+507",
    flagUrl: "https://country-code-au6g.vercel.app/PA.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Peru",
    code: "PE",
    phoneCode: "+51",
    flagUrl: "https://country-code-au6g.vercel.app/PE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "French Polynesia",
    code: "PF",
    phoneCode: "+689",
    flagUrl: "https://country-code-au6g.vercel.app/PF.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Papua New Guinea",
    code: "PG",
    phoneCode: "+675",
    flagUrl: "https://country-code-au6g.vercel.app/PG.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Philippines",
    code: "PH",
    phoneCode: "+63",
    flagUrl: "https://country-code-au6g.vercel.app/PH.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Pakistan",
    code: "PK",
    phoneCode: "+92",
    flagUrl: "https://country-code-au6g.vercel.app/PK.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Poland",
    code: "PL",
    phoneCode: "+48",
    flagUrl: "https://country-code-au6g.vercel.app/PL.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "St. Pierre & Miquelon",
    code: "PM",
    phoneCode: "+508",
    flagUrl: "https://country-code-au6g.vercel.app/PM.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Pitcairn Islands",
    code: "PN",
    phoneCode: "+872",
    flagUrl: "https://country-code-au6g.vercel.app/PN.svg",
    minPhoneDigits: 4,
    maxPhoneDigits: 4,
  },
  {
    name: "Puerto Rico",
    code: "PR",
    phoneCode: "+1939",
    flagUrl: "https://country-code-au6g.vercel.app/PR.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Palestinian Territories",
    code: "PS",
    phoneCode: "+970",
    flagUrl: "https://country-code-au6g.vercel.app/PS.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Portugal",
    code: "PT",
    phoneCode: "+351",
    flagUrl: "https://country-code-au6g.vercel.app/PT.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Palau",
    code: "PW",
    phoneCode: "+680",
    flagUrl: "https://country-code-au6g.vercel.app/PW.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Paraguay",
    code: "PY",
    phoneCode: "+595",
    flagUrl: "https://country-code-au6g.vercel.app/PY.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Qatar",
    code: "QA",
    phoneCode: "+974",
    flagUrl: "https://country-code-au6g.vercel.app/QA.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Réunion",
    code: "RE",
    phoneCode: "+262",
    flagUrl: "https://country-code-au6g.vercel.app/RE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Romania",
    code: "RO",
    phoneCode: "+40",
    flagUrl: "https://country-code-au6g.vercel.app/RO.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Serbia",
    code: "RS",
    phoneCode: "+381",
    flagUrl: "https://country-code-au6g.vercel.app/RS.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 9,
  },
  {
    name: "Russia",
    code: "RU",
    phoneCode: "+7",
    flagUrl: "https://country-code-au6g.vercel.app/RU.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Rwanda",
    code: "RW",
    phoneCode: "+250",
    flagUrl: "https://country-code-au6g.vercel.app/RW.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Saudi Arabia",
    code: "SA",
    phoneCode: "+966",
    flagUrl: "https://country-code-au6g.vercel.app/SA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Solomon Islands",
    code: "SB",
    phoneCode: "+677",
    flagUrl: "https://country-code-au6g.vercel.app/SB.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Seychelles",
    code: "SC",
    phoneCode: "+248",
    flagUrl: "https://country-code-au6g.vercel.app/SC.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Sudan",
    code: "SD",
    phoneCode: "+249",
    flagUrl: "https://country-code-au6g.vercel.app/SD.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Sweden",
    code: "SE",
    phoneCode: "+46",
    flagUrl: "https://country-code-au6g.vercel.app/SE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Singapore",
    code: "SG",
    phoneCode: "+65",
    flagUrl: "https://country-code-au6g.vercel.app/SG.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "St. Helena",
    code: "SH",
    phoneCode: "+290",
    flagUrl: "https://country-code-au6g.vercel.app/SH.svg",
    minPhoneDigits: 4,
    maxPhoneDigits: 5,
  },
  {
    name: "Slovenia",
    code: "SI",
    phoneCode: "+386",
    flagUrl: "https://country-code-au6g.vercel.app/SI.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Svalbard & Jan Mayen",
    code: "SJ",
    phoneCode: "+47",
    flagUrl: "https://country-code-au6g.vercel.app/SJ.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Slovakia",
    code: "SK",
    phoneCode: "+421",
    flagUrl: "https://country-code-au6g.vercel.app/SK.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Sierra Leone",
    code: "SL",
    phoneCode: "+232",
    flagUrl: "https://country-code-au6g.vercel.app/SL.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "San Marino",
    code: "SM",
    phoneCode: "+378",
    flagUrl: "https://country-code-au6g.vercel.app/SM.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 10,
  },
  {
    name: "Senegal",
    code: "SN",
    phoneCode: "+221",
    flagUrl: "https://country-code-au6g.vercel.app/SN.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Somalia",
    code: "SO",
    phoneCode: "+252",
    flagUrl: "https://country-code-au6g.vercel.app/SO.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 8,
  },
  {
    name: "Suriname",
    code: "SR",
    phoneCode: "+597",
    flagUrl: "https://country-code-au6g.vercel.app/SR.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "South Sudan",
    code: "SS",
    phoneCode: "+211",
    flagUrl: "https://country-code-au6g.vercel.app/SS.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "São Tomé & Príncipe",
    code: "ST",
    phoneCode: "+239",
    flagUrl: "https://country-code-au6g.vercel.app/ST.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "El Salvador",
    code: "SV",
    phoneCode: "+503",
    flagUrl: "https://country-code-au6g.vercel.app/SV.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Syria",
    code: "SY",
    phoneCode: "+963",
    flagUrl: "https://country-code-au6g.vercel.app/SY.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Eswatini",
    code: "SZ",
    phoneCode: "+268",
    flagUrl: "https://country-code-au6g.vercel.app/SZ.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Turks & Caicos Islands",
    code: "TC",
    phoneCode: "+1649",
    flagUrl: "https://country-code-au6g.vercel.app/TC.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Chad",
    code: "TD",
    phoneCode: "+235",
    flagUrl: "https://country-code-au6g.vercel.app/TD.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Togo",
    code: "TG",
    phoneCode: "+228",
    flagUrl: "https://country-code-au6g.vercel.app/TG.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Thailand",
    code: "TH",
    phoneCode: "+66",
    flagUrl: "https://country-code-au6g.vercel.app/TH.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Tajikistan",
    code: "TJ",
    phoneCode: "+992",
    flagUrl: "https://country-code-au6g.vercel.app/TJ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Tokelau",
    code: "TK",
    phoneCode: "+690",
    flagUrl: "https://country-code-au6g.vercel.app/TK.svg",
    minPhoneDigits: 4,
    maxPhoneDigits: 4,
  },
  {
    name: "Timor-Leste",
    code: "TL",
    phoneCode: "+670",
    flagUrl: "https://country-code-au6g.vercel.app/TL.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Turkmenistan",
    code: "TM",
    phoneCode: "+993",
    flagUrl: "https://country-code-au6g.vercel.app/TM.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Tunisia",
    code: "TN",
    phoneCode: "+216",
    flagUrl: "https://country-code-au6g.vercel.app/TN.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Tonga",
    code: "TO",
    phoneCode: "+676",
    flagUrl: "https://country-code-au6g.vercel.app/TO.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Turkey",
    code: "TR",
    phoneCode: "+90",
    flagUrl: "https://country-code-au6g.vercel.app/TR.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Trinidad & Tobago",
    code: "TT",
    phoneCode: "+1868",
    flagUrl: "https://country-code-au6g.vercel.app/TT.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Tuvalu",
    code: "TV",
    phoneCode: "+688",
    flagUrl: "https://country-code-au6g.vercel.app/TV.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Taiwan",
    code: "TW",
    phoneCode: "+886",
    flagUrl: "https://country-code-au6g.vercel.app/TW.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Tanzania",
    code: "TZ",
    phoneCode: "+255",
    flagUrl: "https://country-code-au6g.vercel.app/TZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Ukraine",
    code: "UA",
    phoneCode: "+380",
    flagUrl: "https://country-code-au6g.vercel.app/UA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Uganda",
    code: "UG",
    phoneCode: "+256",
    flagUrl: "https://country-code-au6g.vercel.app/UG.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "United States",
    code: "US",
    phoneCode: "+1",
    flagUrl: "https://country-code-au6g.vercel.app/US.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Uruguay",
    code: "UY",
    phoneCode: "+598",
    flagUrl: "https://country-code-au6g.vercel.app/UY.svg",
    minPhoneDigits: 8,
    maxPhoneDigits: 8,
  },
  {
    name: "Uzbekistan",
    code: "UZ",
    phoneCode: "+998",
    flagUrl: "https://country-code-au6g.vercel.app/UZ.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Vatican City",
    code: "VA",
    phoneCode: "+379",
    flagUrl: "https://country-code-au6g.vercel.app/VA.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "St. Vincent & Grenadines",
    code: "VC",
    phoneCode: "+1784",
    flagUrl: "https://country-code-au6g.vercel.app/VC.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Venezuela",
    code: "VE",
    phoneCode: "+58",
    flagUrl: "https://country-code-au6g.vercel.app/VE.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "British Virgin Islands",
    code: "VG",
    phoneCode: "+1284",
    flagUrl: "https://country-code-au6g.vercel.app/VG.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "U.S. Virgin Islands",
    code: "VI",
    phoneCode: "+1340",
    flagUrl: "https://country-code-au6g.vercel.app/VI.svg",
    minPhoneDigits: 10,
    maxPhoneDigits: 10,
  },
  {
    name: "Vietnam",
    code: "VN",
    phoneCode: "+84",
    flagUrl: "https://country-code-au6g.vercel.app/VN.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Vanuatu",
    code: "VU",
    phoneCode: "+678",
    flagUrl: "https://country-code-au6g.vercel.app/VU.svg",
    minPhoneDigits: 7,
    maxPhoneDigits: 7,
  },
  {
    name: "Wallis & Futuna",
    code: "WF",
    phoneCode: "+681",
    flagUrl: "https://country-code-au6g.vercel.app/WF.svg",
    minPhoneDigits: 6,
    maxPhoneDigits: 6,
  },
  {
    name: "Samoa",
    code: "WS",
    phoneCode: "+685",
    flagUrl: "https://country-code-au6g.vercel.app/WS.svg",
    minPhoneDigits: 5,
    maxPhoneDigits: 7,
  },
  {
    name: "Yemen",
    code: "YE",
    phoneCode: "+967",
    flagUrl: "https://country-code-au6g.vercel.app/YE.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Mayotte",
    code: "YT",
    phoneCode: "+262",
    flagUrl: "https://country-code-au6g.vercel.app/YT.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "South Africa",
    code: "ZA",
    phoneCode: "+27",
    flagUrl: "https://country-code-au6g.vercel.app/ZA.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Zambia",
    code: "ZM",
    phoneCode: "+260",
    flagUrl: "https://country-code-au6g.vercel.app/ZM.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 9,
  },
  {
    name: "Zimbabwe",
    code: "ZW",
    phoneCode: "+263",
    flagUrl: "https://country-code-au6g.vercel.app/ZW.svg",
    minPhoneDigits: 9,
    maxPhoneDigits: 10,
  },
];
